/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { useState } from 'react';
import { useViewport } from '@vlinder-web/viewport-provider-react';

import {
  HeaderComp,
  IHeaderCompProps,
  HeroSection,
  IHeroSectionProps,
  ImageFeature,
  IImageFeatureProps,
  MainSection,
  IMainSectionProps,
  Footer,
  IFooterProps,
  Features,
  IFeaturesProps,
  Sidebar,
  ISidebarProps,
  IHowItWorksProps,
  HowItWorks,
} from './components';
import ImageSliderVW from './components';
import { ContactUsPage } from '../contact-us-page-widget/ContactUsPage';

type IAdminLandingPageType = IHeaderCompProps &
  IHeroSectionProps &
  IImageFeatureProps &
  IMainSectionProps &
  IFooterProps &
  ISidebarProps &
  IHowItWorksProps &
  IFeaturesProps &
  IContactUsProps;

export const LandingPage = ({ ...rest }: IAdminLandingPageType) => {
  const { bp, width } = useViewport();
  const [activePage, setActivePage] = useState('Home');

  const _getHeader = () => {
    if (bp === 'xs' || width <= 990) {
      return <Sidebar {...rest} activeButton={activePage} setActiveButton={setActivePage} />;
    } else {
      return <HeaderComp {...rest} activeButton={activePage} setActiveButton={setActivePage} />;
    }
  };

  const _renderBodyContent = () => {
    switch (activePage) {
      case 'Home':
        return (
          <>
            <HeroSection {...rest} />
            <ImageFeature {...rest} />
            <HowItWorks {...rest} />
            <MainSection {...rest} />
            <Features {...rest} />
          </>
        );
      case 'Contact Us':
        return (
          <>
            <ContactUsPage {...rest}/>
          </>
        );
      default:
        return (
          <>
            <HeroSection {...rest} />
            <ImageFeature {...rest} />
            <HowItWorks {...rest} />
            <MainSection {...rest} />
            <Features {...rest} />
          </>
        );
    }
  };

  return (
    <div>
      {_getHeader()}
      {_renderBodyContent()}
      <Footer {...rest} />
    </div>
  );
};

LandingPage.defaultProps = {};